export default "__VITE_ASSET__CnxAtLN8__"